<template>
    <div class="container">
        <div class="main__top">
            <h1 class="main__title wow fadeInDown" data-wow-duration="1.5s">Artists</h1>
        </div>

        <div class="artists">
            <div class="links-panel" v-if="isAdmin">
                <a href="javascript:void(0)" class="registration-link">Registration</a>
                <button
                    type="button"
                    class="btn btn_primary-outline generate-link"
                    @click="getLinkForRegistration"
                >
                    generate link
                </button>
                <div class="holder" :class="{show : registrationLink}">
                    <input type="text" class="txt" :value="registrationLink">
                    <button type="submit" class="btn" @click="copyLink">copy</button>
                </div>
            </div>
            <div class="artists__search">
                <input
                    type="text"
                    class="txt"
                    placeholder="Search by Name"
                    v-model.trim="filters.stage_name"
                    @keydown.enter="updateListOfArtists"
                >
                <button
                    type="submit"
                    class="sbm"
                    area-label="Search Submit"
                    @click.prevent="updateListOfArtists"
                >
                    <svg width="18" height="18" class="icon">
                        <use href="/img/svg/symbol-defs.svg#icon-search"></use>
                    </svg>
                </button>
            </div>
            <div class="filter mt-0">
                <span class="filter__label">Filter:</span>
                <form action="">
                    <div class="row justify-content-between">
                        <div class="col-6 col-md-3">
                            <div class="filter__item">
                                <select
                                    class="custom-select"
                                    v-model="filters.category_id"
                                    @change="updateListOfArtists"
                                >
                                    <option
                                        :value="null"
                                    >Select Category</option>
                                    <option
                                        v-for="category in subcategories"
                                        :key="category.id"
                                        :value="category.id"
                                    > {{ category.search_label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-md-3">
                            <div class="filter__item">
                                <select
                                    class="custom-select"
                                    v-model="filters.subcategory_id"
                                    @change="updateListOfArtists"
                                >
                                    <option
                                        :value="null"
                                    >Select Subcategory</option>
                                    <option
                                        v-for="subcategory in secondarySubcategories"
                                        :key="subcategory.id"
                                        :value="subcategory.id"
                                    > {{ subcategory.search_label }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-md-3">
                            <div class="filter__item">
                                <select
                                    class="custom-select"
                                    v-model="filters.status"
                                    @change="updateListOfArtists"
                                >
                                    <option
                                        :value="null"
                                        selected
                                    >
                                        Select Status
                                    </option>
                                    <option
                                        v-for="(status, index) in statuses"
                                        :key="index"
                                        :value="status"
                                    > {{ status }}
                                    </option>

                                </select>
                            </div>
                        </div>
                        <div class="col-6 col-md-3">
                            <div class="filter__item">
                                <div class="form">
                                    <div class="show-num">
                                        <label class="show-num__label">Show:</label>
                                        <select
                                            class="custom-select pl-3"
                                            @change="updateListOfArtists"
                                            v-model="filters.perPage"
                                        >
                                            <option value="10">10</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            <div class="artists__table">
                <div class="artists__top">
                    <div class="artists__photo"></div>
                    <div class="artists__name">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('stage_name')">stage name <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="artists__category">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('category_name')">category <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="artists__subcategory">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('subcategory_name')">subcategory <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="artists__status">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('status')">status <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="artists__featured">
                        <a href="javascript:void(0)" @click.prevent="changeSortList('featured')">featured <i class="fa-solid fa-sort"></i></a>
                    </div>
                    <div class="artists__delete"></div>
                </div>
                <ul class="artists__list">
                    <li
                        class="artists__item"
                        v-for="artist in artists.data"
                        :key="artist.id"
                    >
                        <div class="artists__photo">
                            <a :href="`/admin/artist/${artist.id}/show`" class="photo">
                                <img :src="getNameOfAvatar(artist.file_avatar)" alt="">
                            </a>
                        </div>
                        <div class="artists__name">
                            <a
                                :href="`/admin/artist/${artist.id}/show`"
                                class="name"
                            > {{ artist.stage_name }}</a>
                        </div>
                        <div class="artists__category">
                            <p
                                v-for="category in artist.categories"
                                :key="category.id"
                            >
                                {{ category.name }}
                            </p>
                        </div>
                        <div class="artists__subcategory">
                            <p
                                v-for="subcategory in artist.subcategories"
                                :key="subcategory.id"
                            >
                                {{ subcategory.name }}
                            </p>
                        </div>
                        <div class="artists__status">
                            <div class="artists__select">
                                <span class="artists__selected artists__selected_pending">
                                    <i class="fa-solid fa-chevron-down" v-show="isAdmin"></i> {{ artist.status }}</span>
                                <div class="artists__tool" v-show="isAdmin">
                                    <button
                                        v-for="(status, index) in statuses"
                                        :key="index"
                                        type="button"
                                        @click="updateArtistStatus(status, artist)"
                                        class="artists__action artists__action_pending"
                                        :class="artist.status === status ? `artists__action_selected` : ''"
                                    >
                                        {{ status }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="artists__featured">
                            <div class="artists__select">
                                <span class="artists__selected">
                                    <i class="fa-solid fa-chevron-down" v-show="isAdmin"></i> {{ artist.featured ? 'Yes' : 'No' }}
                                </span>
                                <div class="artists__tool" v-show="isAdmin">
                                    <button
                                        v-for="(option, index) in [true, false]"
                                        :key="index"
                                        type="button"
                                        class="artists__action"
                                        :class="{ 'artists__action_selected': Boolean(artist.featured) === option }"
                                        @click="updateArtistFeatured(option, artist)"
                                    >
                                        {{ option ? 'Yes' : 'No' }}
                                    </button>
                                </div>

                            </div>
                        </div>
                        <div class="artists__delete" v-if="isAdmin">
                            <button class="delete" area-label="Remove Item" @click="openDeleteModal(artist.id)">
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
            <ActionModal
                :modal-id="getCustomModalId('delete',currentArtistId)"
                @confirm="deleteArtist(currentArtistId)"
                :reject-text="`No`"
                :confirm-text="`Yes`"
            >
                <template #body>
                    <div class="text-center mb-4">
                        <div class="text-center">
                            <h5 class="title">Are you sure ?</h5>
                            <p>Do you want to delete this artist?</p>
                        </div>
                    </div>
                </template>
            </ActionModal>

            <Pagination
                :last-page="artists.last_page"
                :current-page="artists.current_page"
                @changePage="changePage"
            />

        </div>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import Pagination from "../Common/Pagination.vue";
import {useAdminStore} from "../../stores/AdminStore";
import {mapActions, mapState} from "pinia";
import AdminService from "../../services/AdminService";
import ActionModal from "../Common/ActionModal.vue";
import ModalHandler from "../../mixins/ModalHandler";

export default defineComponent({
    name: "ListOfArtists",
    components: {ActionModal, Pagination},

    mixins: [ModalHandler],
    data() {
        return {
            featured: ['Yes', 'No'],
            registrationLink: null,
            currentArtistId: null,
            userType: null,
            filters: {
                stage_name: null,
                page: 1,
                perPage: 10,
                status: null,
                subcategory_id: null,
                category_id: null,
                orderColumn: 'stage_name',
                orderDirection: 'asc'
            }
        }
    },
    computed: {
        ...mapState(useAdminStore, {
            artists: 'artists',
            statuses: 'statuses',
            subcategories: 'subcategories',

            isAdmin() {
                return this.userType === 'admin';
            },

            secondarySubcategories() {
                if (this.filters.category_id) {
                    const found = this.subcategories.find(category => category.id === this.filters.category_id)
                    if (found) {
                        return found.subcategories
                    }
                } else {
                    this.filters.subcategory_id = null
                    this.fetchListOfArtists(this.filters)
                    return null
                }
            }
        })
    },

    methods: {
        ...mapActions(useAdminStore, {
            fetchListOfArtists: 'fetchListOfArtists',
            fetchListOfStatuses: 'fetchListOfStatuses',
            fetchListOfSubcategories: 'fetchListOfSubcategories'
        }),

        getNameOfAvatar(photo) {
            return photo ? `/uploads${photo.file_path}` : "/img/svg/avatar.svg";
        },

        copyLink() {
            navigator.clipboard.writeText(this.registrationLink)
        },

        async getLinkForRegistration() {
            this.$showLoadingMessage()
            try {
               const { data: response } =  await AdminService.getRegistrationLink('artist')
                this.registrationLink = response.url
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('Status was not updated')
            }
        },

        changeSortList(field) {
            if (this.filters.orderColumn === field) {
                this.filters.orderDirection = this.filters.orderDirection === 'asc' ? 'desc' : 'asc';
            }
            this.filters.orderColumn = field
            this.fetchListOfArtists(this.filters)
        },

        openDeleteModal(id) {
            this.currentArtistId = id
            this.showCustomModal('delete', id)
        },

        updateListOfArtists() {
            this.fetchListOfArtists(this.filters)
        },

        changePage(page) {
            this.filters.page = page
            this.fetchListOfArtists(this.filters)
        },
        async updateArtistStatus(status, artist) {
            artist.status = status
            try {
                await AdminService.updateArtistStatus(artist.id, status)
                this.$showSuccessMessage('Status was updated')
            } catch (error) {
                this.$showErrorMessage('Status was not updated')
                console.error(error)
            }
        },
        async updateArtistFeatured(featured, artist) {
            artist.featured = featured
            try {
                await AdminService.updateArtistFeatured(artist.id, featured)
                this.$showSuccessMessage('Status was updated')
            } catch (error) {
                this.$showErrorMessage('Status was not updated')
                console.error(error)
            }
        },
        async getAdminType() {
            try {
               const response = await AdminService.getAdminType()
                this.userType = response.data
            } catch (error) {
                this.$showErrorMessage('Status was not updated')
                console.error(error)
            }
        },
        async deleteArtist(id) {
            try {
                await AdminService.deleteArtist(id)
                this.$showSuccessMessage('The Artist was deleted')
            } catch (e) {
                this.$showErrorMessage('The Artist was not deleted, please try again')
            }
        }
    },
    mounted() {
        this.getAdminType()
        this.fetchListOfArtists(this.filters)
        this.fetchListOfStatuses()
        this.fetchListOfSubcategories()
    }

})
</script>


<style scoped>

</style>
